import { useState } from "react";
import { FaSearch } from "react-icons/fa";

export default function SearchBox({ query, setQuery }) {
  return (
    <div className="flex-1 items-center w-[100%]">
      <form
        className="relative w-[100%] bg-blue-500 rounded-lg"
        onSubmit={(e) => e.preventDefault()}
        role="search"
      >
        <label htmlFor="search" className="sr-only">
          Search for stuff
        </label>
        <div className="relative">
          <input
            id="search"
            type="search"
            placeholder="Search..."
            autoFocus
            required
            autoComplete="off"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="h-10 w-full bg-white text-gray-900 text-sm pl-4 pr-10 rounded transition-all duration-300 ease-in-out focus:outline-none focus:ring-1 focus:ring-blue-300 focus:border-blue-300"
          />
          <button
            className={`absolute top-1/2 transform hover:text-blue-500 hover:font-bold -translate-y-1/2 right-3 text-blue-400 focus:text-blue-400 transition-transform duration-500 ease-in-out ${
              query ? "translate-x-0 opacity-100" : "translate-x-3 opacity-0"
            }`}
          >
            <FaSearch />
          </button>
        </div>
      </form>
    </div>
  );
}
